package com.mencanhealth.admin.ui

import androidx.compose.runtime.*
import com.mencanhealth.admin.data.AdminFirestoreService
import com.mencanhealth.admin.model.DashboardStats
import com.mencanhealth.admin.ui.components.StatCard
import org.jetbrains.compose.web.dom.*

@Composable
fun AnalyticsPage(firestoreService: AdminFirestoreService) {
    var stats by remember { mutableStateOf(DashboardStats()) }
    var loading by remember { mutableStateOf(true) }

    LaunchedEffect(Unit) {
        stats = firestoreService.getStats()
        loading = false
    }

    Div({ classes("page") }) {
        H2 { Text("Analytics") }

        if (loading) {
            P { Text("Loading stats...") }
        } else {
            Div({ classes("stats-grid") }) {
                StatCard("Total Users", stats.totalUsers.toString(), "stat-total")
                StatCard("Free", stats.freeUsers.toString(), "stat-free")
                StatCard("Pro", stats.proUsers.toString(), "stat-pro")
                StatCard("Premium", stats.premiumUsers.toString(), "stat-premium")
                StatCard("Admin", stats.adminUsers.toString(), "stat-admin")
            }
        }
    }
}
